<script setup lang="ts">
const { t } = useI18n()
</script>
<template>
  <div class="form-section--2-cols">
    <TelInput id="phones-mobile" name="mobile" :label="t('tocco.registration.personalInfo.mobile')" :required="true" />
    <TelInput id="phones-phone" name="phone" :label="t('tocco.registration.personalInfo.phone')" :required="false" />
  </div>
</template>
